import React from 'react';

import * as Styled from './step-card.styled';

type OwnProps = {
	icon: string;
	step: string;
	text: string;
};

const StepCard: React.FC<OwnProps> = ({ icon, step, text }) => {
	return (
		<Styled.Wrapper>
			<Styled.IconWrapper>
				<img src={icon} alt='icon' />
			</Styled.IconWrapper>
			<Styled.Content>
				<Styled.Step>{step}</Styled.Step>
				<Styled.Text>{text}</Styled.Text>
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default StepCard;
